<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-layout justify-center>
        <v-dialog v-model="show" width="600px">
            <v-card>
                <v-toolbar dark color="blue lighten-2">
                    <v-btn icon dark @click="show = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Переход</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn dark text @click="saveValue" :disabled="!valid">
                            <v-icon>save</v-icon>
                            {{jumpModel.id === null ? ' Создать' : ' Сохранить'}}
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-list subheader class="content">
                    <v-container>
                        <v-form
                                ref="form"
                                v-model="valid"
                        >
                            <v-row class="d-flex">
                                <v-col cols="12" md12 class="py-0">
                                    <v-text-field
                                            v-model="jumpModel.title"
                                            :counter="20"
                                            label="Название перехода"
                                            required
                                            :rules="[rules.required, rules.minLengthTitle, rules.mazLengthTitle]"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="10" md10 class="py-0">
                                    <v-text-field
                                            v-model="url"
                                            label="Краткая ссылка"
                                            required
                                            :readonly="true"
                                            hide-details
                                            ref="urlText"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="2" md2 class="mb-auto" v-if="jumpModel.id !== null">
                                    <v-tooltip left bottom >
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                 depressed
                                                 fab
                                                 small
                                                 text
                                                 v-on="on"
                                                 v-clipboard:copy="url"
                                                 v-clipboard:success="onCopy"
                                                 v-clipboard:error="onError"
                                            >
                                                <v-icon small color="blue lighten-2">file_copy</v-icon>
                                            </v-btn>
                                        </template>
                                        <span >Скопировать ссылку в буфер обмена</span>
                                    </v-tooltip>
                                </v-col>
                                <v-col cols="12" md12 class="py-0">
                                    <v-text-field
                                            type="url"
                                            v-model="jumpModel.url"
                                            label="Ваша ссылка ( начинающаяся c http:// или https://)"
                                            required
                                            :rules="[rules.urlValid]"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                </v-list>
            </v-card>
        </v-dialog>
        <v-snackbar
                v-model="snackbar"
                bottom
                :color="paramsSnackbar.color"
                right
        >
            {{paramsSnackbar.text}}
            <v-btn
                    dark
                    text
                    @click="snackbar = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
    </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import constConf from '../../../constconf'
export default {
    name: 'JumpForm',
    props: ['index', 'dialog', 'edit'],
    data() {
        return {
            show: false,
            jumpModel: null,
            paramsSnackbar: {
                color: 'success',
                text: 'Успешно сохранено!'
            },
            snackbar: false,
            rules: {
                required: value => !!value || 'Обязательное поле.',
                minLengthTitle: value => value.length >= 2 || 'Минимальная длина названия 2 символа.',
                mazLengthTitle: value => value.length <= 20 || 'Максимальная длина названия 20 символов.',
                urlValid: value => (value !== null ? !!value.match(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9А-яЁё]+([\-\.]{1}[a-z0-9А-яЁё]+)*\.[a-zА-яЁё]{2,10}(:[0-9]{1,5})?(\/.*)?$/g) : false) || 'Ссылка имеет неверный формат. Пример верного формата https://app.chatway.ru/'
            },
            valid: false
        }
    },
    methods: {
        saveValue() {
            this.$store.dispatch('jumps/saveJump', this.jumpModel).then(response => {
                if (response.type === 'CreateResult' || response.type === 'UpdateResult') {
                    this.jumpModel.id = response.response.data.id
                    this.paramsSnackbar.color = 'success'
                    this.paramsSnackbar.text = 'Сохранение/создание прошло успешно!'
                } else {
                    this.paramsSnackbar.color = 'error'
                    this.paramsSnackbar.text = 'Ошибка при сохранении/создании перехода'
                }
                this.snackbar = true
            })
        },
        loadModel(index = null) {
            if (index === null) {
                this.jumpModel = Object.assign({}, this.jumpModelDef)
            } else {
                this.jumpModel = Object.assign({}, this.jumps[index])
            }
        },
        onCopy() {
            this.paramsSnackbar.color = 'success'
            this.paramsSnackbar.text = 'Ссылка успешно скопирована!'
            this.snackbar = true
        },
        onError() {
            this.paramsSnackbar.color = 'error'
            this.paramsSnackbar.text = 'Ошибка при копировании'
            this.snackbar = true
        }
    },
    watch: {
        dialog() {
            if (this.dialog === true) {
                this.loadModel(this.index)
                this.show = true
            } else {
                this.show = false
            }
        },
        show() {
            if (this.show === false) {
                this.jumpModel = Object.assign({}, this.jumpModelDef)
                this.$refs.form.resetValidation()
                this.$emit('close')
            }
        }
    },
    computed: {
        ...mapGetters({
            jumps: 'jumps/jumps',
            jumpModelDef: 'jumps/modelDefault'
        }),
        url() {
            return this.jumpModel.id == null ? '' : constConf.baseURL.url + '/' + this.jumpModel.id
        }
    },
    created() {
        this.$store.dispatch('jumps/changeBotIdModelDefault', this.$route.params['pathMatch'])
        this.jumpModel = Object.assign({}, this.jumpModelDef)
    }
}
</script>

<style scoped>

</style>
